import type { HelpFile } from '../../types/help'
import { FooterTestIds } from '../../../testids/FooterTestIds'

export const footerHelp: HelpFile = {
  docPage: '/docs/about',
  texts: {
    [FooterTestIds.appFooter]:
      'Persistente Fußzeile, die die aktuelle Backend-Build-Version für Tenant-Administratoren und Support-Engineers anzeigt.',
    [FooterTestIds.footerVersion]:
      'Backend-Build-Version — hilfreich für die Vorfallanalyse und das Release-Rollout-Monitoring.',
    [FooterTestIds.footerGitTag]:
      'Git-Tag des laufenden Backend-Builds — identifiziert das exakte Release-Artefakt.',
    [FooterTestIds.footerGitBranch]:
      'Git-Branch, aus dem das Backend gebaut wurde — unterscheidet Mainline-Builds von Feature-Branches.',
  },
}
